import script from "./CobrancasPublicas.vue?vue&type=script&setup=true&lang=js"
export * from "./CobrancasPublicas.vue?vue&type=script&setup=true&lang=js"

import "./CobrancasPublicas.vue?vue&type=style&index=0&id=0afccde0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0afccde0"]])

export default __exports__